import { HourWiseEfficiencyModel } from "./hour-wise-efficiency.model";

export class LineWorkStationEfficiencyModel {
    totalEfficiency: number; // percentage
    hourWiseEfficiency: HourWiseEfficiencyModel[];

    constructor(totalEfficiency: number,
        hourWiseEfficiency: HourWiseEfficiencyModel[]) {
            this.totalEfficiency = totalEfficiency;
            this.hourWiseEfficiency = hourWiseEfficiency;
    }
}

